(function ($) {
  DJ.addBehavior('commentsAccordion', '.comments__body', {
    attach: function () {
      const allIndented = document.querySelectorAll('.comments__body > .indented');
      const replyButtons = document.querySelectorAll('.comments__body > .comment .js-ajax-comments-reply');
      const indentedClosedClass = 'indented--closed';
      const pageName = window.location.pathname;

      if (allIndented.length) {
        Array.prototype.slice.call(allIndented).forEach((item) => {
          const accordionTrigger = document.createElement('button');

          accordionTrigger.textContent = 'Réduire le fil de discussion';
          accordionTrigger.classList.add('comments-accordion-button');
          accordionTrigger.setAttribute('type', 'button');
          accordionTrigger.setAttribute('data-opened', 'true');
          accordionTrigger.setAttribute('aria-expanded', 'true');

          item.appendChild(accordionTrigger);
        });
      }

      if (replyButtons.length) {
        Array.prototype.slice.call(replyButtons).forEach((item, index) => {
          item.addEventListener('click', () => {
            const $comment = $(item).closest('.comment').attr('id');
            localStorage.setItem(`comments_opened-${pageName}`, $comment);
          });
        });
      }

      /**
       * Set attribute for the elements.
       *
       * @param {Array} elements
       *  Elements for which need to set attribute.
       * @param {string} attrName
       *  Attribute name.
       *  @param {string} value
       *  Attribute value.
       */
      const setAttrForEach = (elements, attrName, value) => {
        elements.forEach((e) => {
          e.setAttribute(attrName, value);
        });
      };

      /**
       * Remove attribute for the elements.
       *
       * @param {Array} elements
       *  Elements for which need to set attribute.
       * @param {string} attrName
       *  Attribute name.
       */
      const removeAttrForEach = (elements, attrName) => {
        elements.forEach((e) => {
          e.removeAttribute(attrName);
        });
      };

      const closeAllItems = () => {
        if (allIndented.length) {
          Array.prototype.slice.call(allIndented).forEach((item) => {
            const itemTrigger = item.querySelector('.comments-accordion-button');
            const itemContent = Array.prototype.slice.call(item.querySelectorAll('.comment'));

            if (!itemTrigger || !itemContent.length) {
              return false;
            }

            itemTrigger.setAttribute('aria-expanded', 'false');
            itemTrigger.setAttribute('data-opened', 'false');
            itemTrigger.textContent = 'Afficher le fil de discussion';
            setAttrForEach(itemContent, 'hidden', '');
            item.classList.add(indentedClosedClass);

            return true;
          });
        }
      };

      /**
       * On 'pageshow' close all accordions and clear local storage.
       */
      window.addEventListener('pageshow', function (event) {
        closeAllItems();
        localStorage.removeItem(`comments_opened-${pageName}`);
      });

      /**
       * When init opens accordions according to info from local storage and close other.
       */
      const accordionInit = () => {
        setTimeout(() => {
          if (allIndented && allIndented.length) {
            const commentOpened = localStorage.getItem(`comments_opened-${pageName}`);

            closeAllItems();

            if (commentOpened) {
              const $closestComment = $(`#${commentOpened}`);

              if ($closestComment.length === 0) {
                return false;
              }

              let indented;

              if ($closestComment.next().hasClass('indented')) {
                indented = $closestComment.next();
              } else if ($closestComment.next().next().hasClass('indented')) {
                indented = $closestComment.next().next();
              } else {
                return false;
              }

              const triggerToOpen = indented[0].querySelector('.comments-accordion-button');
              const commentsToOpen = Array.prototype.slice.call(indented[0].querySelectorAll('.comment'));

              if (triggerToOpen && commentsToOpen.length) {
                triggerToOpen.textContent = 'Réduire le fil de discussion';
                triggerToOpen.setAttribute('aria-expanded', 'true');
                triggerToOpen.setAttribute('data-opened', 'true');
                removeAttrForEach(commentsToOpen, 'hidden');
                indented[0].classList.remove(indentedClosedClass);
              }

              return true;
            }
          }

          return true;
        }, 1);
      };

      $(document).ajaxComplete(() => {
        const deleteButton = $('.comment-comment-delete-form .button--primary');

        if (deleteButton.length !== 0) {
          deleteButton.on('click', () => {
            closeAllItems();
            localStorage.removeItem(`comments_opened-${pageName}`);
          });
        } else {
          accordionInit();
        }
      });

      /**
       * Add event click on accordion trigger.
       * On click open/close accordion element.
       */
      if (allIndented.length) {
        Array.prototype.slice.call(allIndented).forEach((item) => {
          const itemTrigger = item.querySelector('.comments-accordion-button');
          const itemContent = Array.prototype.slice.call(item.querySelectorAll('.comment'));

          itemTrigger.addEventListener('click', function () {
            const isExpanded = itemTrigger.getAttribute('aria-expanded') === 'true';

            function toggleAccordion(ariaExpandedValue, ariaControlsSetRemove) {
              itemTrigger.setAttribute('aria-expanded', ariaExpandedValue);

              if (ariaControlsSetRemove) {
                setAttrForEach(itemContent, 'hidden', '');
                itemTrigger.textContent = 'Afficher le fil de discussion';
                itemTrigger.setAttribute('data-opened', 'false');
                item.classList.add(indentedClosedClass);
              } else {
                removeAttrForEach(itemContent, 'hidden');
                itemTrigger.textContent = 'Réduire le fil de discussion';
                itemTrigger.setAttribute('data-opened', 'true');
                item.classList.remove(indentedClosedClass);
              }
            }

            if (isExpanded) {
              toggleAccordion('false', true);
            } else {
              closeAllItems();
              toggleAccordion('true', false);
            }

            let openedComment;

            Array.prototype.slice.call(document.querySelectorAll('.comments-accordion-button')).forEach((btn, index) => {
              if (btn.getAttribute('data-opened') === 'true') {
                const prevElement = $(btn).closest('.indented').prev();

                if (prevElement.hasClass('comment')) {
                  openedComment = prevElement.attr('id');
                } else if (prevElement.prev().hasClass('comment')) {
                  openedComment = prevElement.prev().attr('id');
                } else {
                  return false;
                }
              }

              return true;
            });

            if (openedComment) {
              localStorage.setItem(`comments_opened-${pageName}`, openedComment);
            }
          });

          /**
           * Add event keydown on accordion trigger.
           * On keydown open/close accordion element.
           */
          itemTrigger.addEventListener('keydown', function (el) {
            const code = el.keyCode || el.which;

            if (code === 13) {
              $(this).click();
            }
          });
        });
      }
    }
  });
})(jQuery);
